import { InjectableClass } from '@fino/lib-injection';
import _ from 'lodash';

export class ConfirmFinancesService extends InjectableClass {
  constructor(
    FinanceTypes,
    FinanceTypeDocuments,
    FinanceSequencyTypes,
    FinanceIntervalTypes,
    FinanceDirectDebitProperties,
    FinanceReceivedPaymentProperties,
    FinanceStandingOrdersProperties,
    dataGenerator,
    ticketService,
    TicketStates,
    financesDirectDebitsTemplate,
    financesReceivedPaymentTemplate,
    financesStandingOrdersTemplate,
    PaymentPartnersSuggestTemplate,
  ) {
    'ngInject';
    super({
      FinanceTypes,
      FinanceTypeDocuments,
      FinanceSequencyTypes,
      FinanceIntervalTypes,
      FinanceDirectDebitProperties,
      FinanceReceivedPaymentProperties,
      FinanceStandingOrdersProperties,
      dataGenerator,
      ticketService,
      TicketStates,
      financesDirectDebitsTemplate,
      financesReceivedPaymentTemplate,
      financesStandingOrdersTemplate,
      PaymentPartnersSuggestTemplate,
    });
  }

  get sequenceTypeOptions() {
    return {
      modelKey: 'key',
      selectables: this.FinanceSequencyTypes,
    };
  }

  get intervalTypeOptions() {
    return {
      modelKey: 'key',
      selectables: this.FinanceIntervalTypes,
    };
  }

  get directDebitProperties() {
    return this.FinanceDirectDebitProperties;
  }

  get receivedPaymentProperties() {
    return this.FinanceReceivedPaymentProperties;
  }

  get standingOrdersProperties() {
    return this.FinanceStandingOrdersProperties;
  }

  mapTicketDocuments(documents) {
    const { FinanceTypes, FinanceTypeDocuments } = this;

    return documents
      .filter((doc) =>
        [
          FinanceTypes.directDebits.docDescription,
          FinanceTypes.receivedPayments.docDescription,
          FinanceTypes.standingOrders.docDescription,
        ].includes(doc.description),
      )
      .reduce((result, doc) => {
        let type = FinanceTypeDocuments[doc.description];
        result[type] = doc.url;
        return result;
      }, {});
  }

  /**
   * Returns the document description for the given ticket
   * which depends on the ticket status.
   */
  getDocumentDescriptionByTicket(ticket) {
    const { BALANCE_LIST_DOCUMENT_RECEIVED, BALANCE_LIST_DATA_RECEIVED } =
      this.TicketStates;
    if (
      this.ticketService.hasStatus(ticket, [
        BALANCE_LIST_DOCUMENT_RECEIVED,
        BALANCE_LIST_DATA_RECEIVED,
      ])
    ) {
      return 'BALANCE_LIST';
    }
    return 'BALANCE_LIST';
  }

  getTicketFallbackDocument(ticket) {
    return (
      this.findDocumentByDescription(ticket.documents, 'BALANCE_LIST') ||
      this.findDocumentByDescription(ticket.documents, 'TRANSACTION_DATA')
    );
  }

  findDocumentByDescription(documents, description) {
    return _.findLast(
      _.filter(documents, { description }),
      (doc) => !doc.preliminary && !doc.rejectionReason,
    );
  }

  resetForm(form) {
    form.$setPristine();
    form.$setUntouched();
  }

  fillFormData(form, editor) {
    _.forEach(form, (value, key) => {
      if (key.indexOf('$') === 0) {
        return;
      }

      let field = {
        type: 'text',
        name: key,
      };

      switch (key) {
        case 'sequenceType': {
          _.assign(field, {
            type: 'select',
            options: this.sequenceTypeOptions,
          });
          break;
        }
        case 'interval': {
          _.assign(field, {
            type: 'select',
            options: this.intervalTypeOptions,
          });
          break;
        }
        case 'nextExecution':
        case 'lastExecution': {
          _.assign(field, {
            type: 'date',
          });
          break;
        }
        case 'iban': {
          _.assign(field, {
            options: {
              validate: 'iban',
            },
          });
          break;
        }
        case 'iban-bankcode':
        case 'iban-accountnumber': {
          _.assign(field, {
            type: 'number',
            options: {
              pattern: '[0-9]{8}',
            },
          });
          break;
        }
        case 'currency': {
          field.type = 'select';
          field.value = 'EUR';
          break;
        }
      }

      editor.item[key] = this.getRandomData(field);
    });
  }

  getRandomData(field) {
    const { type, name, value } = field;
    const options = angular.extend({}, field.options || {}, {
      type,
      name,
      value,
      minLength: 3,
      maxLength: 10,
    });

    return this.dataGenerator.generate(options);
  }
}
